/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookies from 'js-cookie';
import { FC, createContext, useState, ReactChild, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
interface UserContext {
  user?: any;
  setUser?: any;
  userTrigger?: any;
  setUserTrigger?: any;
  rePing?: any;
  setRePing?: any;
  rePinging?: any;
  setRePinging?: any;
  logout?: any;
  setToken?: any;
  isUserRole?: any;
  handleSetSelectedRole?: any;
}

const context = createContext<UserContext>({});

const { Provider } = context;

interface Props {
  children: ReactChild | ReactChild[];
}

export const UserProvider: FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>();
  const [userTrigger, setUserTrigger] = useState<boolean>();
  const [rePing, setRePing] = useState<boolean>(false);
  const [rePinging, setRePinging] = useState<boolean>(false);

  const setToken = (token: string, username: string, admin: string) => {
    Cookies.set('token', token);
    Cookies.set('username', username);
    Cookies.set('admin', admin);
  };
  const logout = () => {
    setUser({ isLoggedIn: false, Username: null, Roles: [] });
    Cookies.remove('admin');
    Cookies.remove('username');
    Cookies.remove('token');
    navigate('/auth/login');
  };
  const isUserRole = (role: string) => {
    return user.selectedRole === role;
    // return user.Roles.includes(role);
  };

  const handleSetSelectedRole = (role: string) => {
    setUser((pre: any) => {
      return { ...pre, selectedRole: role };
    });
  };

  return (
    <Provider
      value={{
        user,
        setUser,
        userTrigger,
        setUserTrigger,
        rePing,
        setRePing,
        rePinging,
        setRePinging,
        logout,
        isUserRole,
        setToken,
        handleSetSelectedRole
      }}>
      {children}
    </Provider>
  );
};

export const useUser = () => useContext(context);
